export default __webpack_public_path__ + "static/media/B0000.e84307d3.png";